module.exports = __webpack_public_path__ + "static/media/requested-bind.eb7779ca.svg";